export default __webpack_public_path__ + "static/media/sheild.3fece1d5.png";